import React, { Component } from "react";
import {
  profile,
  GET,
  POST,
  PUT,
  alert,
  loading,
  isLoggedIn,
  twofa,
  decode2fa,
  format_date,
  toFixed,
  total,
  mode,
  setDarkMode,
  linkRole,
  Select,
  setCsrfToken,
} from "./CustomComponent.js";
import { captureShareImage } from "./shareHelper.js";
import { Navbar, Nav, Modal } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import LOGO from "../assets/images/logo-landscape2.png";
import LOGO512 from "../assets/images/logo512.png";
import NOTIFICATION from "../assets/images/noti/noti_system6_1.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

import RANK1 from "../assets/images/rank/rank1.png";
import RANK2 from "../assets/images/rank/rank2.png";
import RANK3 from "../assets/images/rank/rank3.png";
import RANK4 from "../assets/images/rank/rank4.png";
import RANK5 from "../assets/images/rank/rank5.png";
import RANK6 from "../assets/images/rank/rank6.png";
// ยอดเงินล่าสุดเก็บไว้ในเครื่อง (แยกตาม user) ให้ refresh หน้าแล้วแสดงยอดเดิมทันที ไม่ขึ้น 0 ก่อนโหลดเสร็จ
// logout ล้าง localStorage ทั้งหมดอยู่แล้ว · ยอดจริงอัปเดตทับเมื่อ wallets/list ตอบกลับ
const WALLET_CACHE_KEY = () => `scp-wallet-cache:${profile?.uid || ""}`;
const readWalletCache = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(WALLET_CACHE_KEY()) || "null");
    return cached && typeof cached === "object" ? cached : {};
  } catch (e) {
    return {};
  }
};
const writeWalletCache = (balances) => {
  try {
    localStorage.setItem(WALLET_CACHE_KEY(), JSON.stringify(balances));
  } catch (e) {}
};

export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    const walletCache = readWalletCache();
    this.state = {
      total_balance_available_thb: walletCache.total_balance_available_thb || 0,
      total_balance_available_lak: walletCache.total_balance_available_lak || 0,
      total_balance_thb: walletCache.total_balance_thb || 0,
      total_balance_lak: walletCache.total_balance_lak || 0,
      dropdown: "",
      array_link: [...this.filterMenu(profile)],
      user_profile: profile,
      modal_news: false,
      announce_datetime: "",
      announce_duration: 0,
      announce_detail: "",
      modal_switch_user: false,
      switch_users: [],
      switch_search: "",
      switch_user_type: "",
      switch_user_counts: {
        all: 0,
        admin: 0,
        accounting: 0,
        broker: 0,
        sub_broker: 0,
        agent: 0,
      },
      switch_selected_user: null,
      switch_loading: false,
      switch_submitting: false,
      switch_btn_hover: false,
      share_image: "",
    };
    this.badgeInterval = null;
  }

  icon = (io) => <span className="icon">{io}</span>;

  // Leave an impersonated session: restore the original account.
  // การ์ด #31: token จริงอยู่ใน httpOnly cookie อ่าน/สลับจาก JS เองไม่ได้แล้ว ต้องให้ backend
  // สลับ cookie กลับให้ (มันเก็บ token เดิม stash ไว้ใน scp_original_tk cookie ตอน switch-profile)
  // ส่วน scp-original-profile / scp-original-2fa เป็นแค่ข้อมูลแสดงผล ไม่ใช่ credential เก็บใน localStorage ได้ตามเดิม
  ExitImpersonation = async () => {
    loading(true);
    const result = await POST("v1/admin/users/exit-impersonation", {});
    loading(false);
    if (!result?.status) {
      // บัญชีตั้งต้นใช้กลับไม่ได้แล้ว (หมดอายุ/login ที่อื่น) ค้างเป็น user ที่สวมสิทธิ์ต่อไม่ได้
      // ล้างสถานะหน้าเว็บแล้วให้ login ใหม่ — ไม่เรียก logout เพราะจะล้าง token ของ user ที่ถูกสวมสิทธิ์ (คนจริง) ไปด้วย
      if (result?.message === "Original session has expired, please log in again") {
        const theme = localStorage.getItem("mode") || "light";
        localStorage.clear();
        localStorage.setItem("mode", theme);
        // POST แสดง popup เตือนไปแล้ว (alert() จะไม่เปิดซ้อน) รอให้ผู้ใช้กดปิดก่อน แล้วค่อยพาไปหน้า login
        while (document.querySelector(".swal2-container")) {
          await new Promise((resolve) => setTimeout(resolve, 200));
        }
        window.location.href = "/";
      }
      return;
    }
    // backend ตั้งคุกกี้ชุดของ super_user กลับมาพร้อม csrf token ตัวใหม่
    setCsrfToken(result?.data?.csrf_token);
    const pf = localStorage.getItem("scp-original-profile");
    const fa = localStorage.getItem("scp-original-2fa");
    if (pf) localStorage.setItem("scp-profile", pf);
    if (fa) localStorage.setItem("scp-2fa", fa);
    else localStorage.removeItem("scp-2fa");
    localStorage.removeItem("scp-original-profile");
    localStorage.removeItem("scp-original-2fa");
    window.location.href = "/su/developer-mode";
  };

  componentDidMount = async () => {
    if (mode === "dark") {
      setDarkMode();
    }
    // โหลดโปรไฟล์
    await this.GetProfile();
    this.scrollActiveMenuIntoView();

    // ตรวจสอบการล็อกอิน
    if (!profile) {
      window.location.href = "/";
      return;
    } else if (isLoggedIn && !twofa) {
      window.location.href = "/verify-2fa";
    } else {
      // เตะออกเฉพาะตอน "รู้ทั้งสองฝั่งแล้วไม่ตรงกันจริงๆ" (เช่น session ค้างจากบัญชีอื่น)
      // ถ้าฝั่งใดฝั่งหนึ่งไม่มีค่า แปลว่าโปรไฟล์ที่เก็บไว้เป็นคนละรูปแบบ ไม่ใช่หลักฐานว่าสวมสิทธิ์ผิดคน
      // ห้ามเคลียร์ session ทิ้ง ไม่งั้นผู้ใช้จะติดวน login -> dashboard -> เด้งกลับ login ไม่จบ
      const twofaUid = (decode2fa(twofa) || "").split(":")[0];
      if (twofaUid && profile?.uid && twofaUid !== profile.uid) {
        const mode = localStorage.getItem("mode") || "light";
        localStorage.clear();
        localStorage.setItem("mode", mode);
        window.location.href = "/";
      }
    }

    // โหลดประกาศ
    if (window.location.href.includes("dashboard")) {
      this.GetAnnounce();
    }

    // ตั้งโหมดธีม
    if (mode === "dark") {
      setDarkMode();
    }

    // โหลดยอดรวมโบรกเกอร์
    if (["super_user", "admin"].includes(profile?.user_type)) {
      this.GetCard();
      this.GetBadgeCount();
      this.badgeInterval = setInterval(() => {
        this.GetBadgeCount();
      }, 30000);
    }

    // โหลดบาลานซ์
    if (!["agent"].includes(profile?.user_type)) {
      let result_wallet = await GET("wallets/list", null);
      let _result_thb =
        result_wallet.data?.rows?.filter((e) => e.currency === "THB") || [];
      let _result_lak =
        result_wallet.data?.rows?.filter((e) => e.currency === "LAK") || [];
      // ตอบไม่สำเร็จ (ไม่มี rows) คงยอดเดิมไว้ ไม่ทับเป็น 0
      if (!Array.isArray(result_wallet?.data?.rows)) return;
      const balances = {
        total_balance_available_thb: total(_result_thb, "balance"),
        total_balance_available_lak: total(_result_lak, "balance"),
        total_balance_thb: total(_result_thb, "balance_t1"),
        total_balance_lak: total(_result_lak, "balance"),
      };
      this.setState(balances);
      writeWalletCache(balances);
    }
  };
  GetProfile = async () => {
    const result = await GET("v1/admin/users/profile");
    if (result?.status) {
      localStorage.setItem("scp-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [...this.filterMenu(result.data)],
      });
      this.permissionSetting();
    }
  };
  GetAnnounce = async () => {
    let result_config = await GET("v1/admin/center-configs/list", null);
    const announce = new Date(result_config?.data?.announce_datetime);
    const now = new Date();
    const deadline = new Date(announce);
    deadline.setHours(deadline.getHours() + 1);
    if (now < deadline) {
      this.setState({
        modal_news: true,
        announce_datetime: result_config?.data?.announce_datetime,
        announce_duration: result_config?.data?.announce_duration,
        announce_detail: result_config?.data?.announce_detail,
      });
    }
    if (!this.share) return;

    const image = await captureShareImage(this.share);
    this.setState({ modal_share: true, share_image: image });

    // ปรับขนาดฟอนต์ในประกาศ
    // this.resizeFont();
  };
  GetCard = async () => {
    let uid = "";
    let result_broker = await GET("v1/admin/brokers", {
      page_size: 100000,
      page: 0,
      data_search: "",
      uid: uid,
    });
    if (result_broker?.status) {
      let total_deposits_thb = 0,
        total_withdrawals_thb = 0,
        total_balance_thb = 0,
        order_deposits_thb = 0,
        order_withdrawals_thb = 0,
        total_deposits_lak = 0,
        total_withdrawals_lak = 0,
        total_balance_lak = 0,
        order_deposits_lak = 0,
        order_withdrawals_lak = 0;
      if (result_broker.data) {
        for (let item of result_broker.data) {
          total_deposits_thb +=
            Number(
              item.gateway_active.find((e) => e.currency === "THB")
                ?.total_deposits,
            ) || 0;
          total_withdrawals_thb +=
            Number(
              item.gateway_active.find((e) => e.currency === "THB")
                ?.total_withdrawals,
            ) || 0;
          total_balance_thb +=
            Number(item.wallets?.find((e) => e.currency === "THB")?.balance) ||
            0;
          order_deposits_thb +=
            Number(
              item.gateway_active.find((e) => e.currency === "THB")
                ?.order_deposits,
            ) || 0;
          order_withdrawals_thb +=
            Number(
              item.gateway_active.find((e) => e.currency === "THB")
                ?.order_withdrawals,
            ) || 0;
          total_deposits_lak +=
            Number(
              item.gateway_active.find((e) => e.currency === "LAK")
                ?.total_deposits,
            ) || 0;
          total_withdrawals_lak +=
            Number(
              item.gateway_active.find((e) => e.currency === "LAK")
                ?.total_withdrawals,
            ) || 0;
          total_balance_lak +=
            Number(item.wallets?.find((e) => e.currency === "LAK")?.balance) ||
            0;
          order_deposits_lak +=
            Number(
              item.gateway_active.find((e) => e.currency === "LAK")
                ?.order_deposits,
            ) || 0;
          order_withdrawals_lak +=
            Number(
              item.gateway_active.find((e) => e.currency === "LAK")
                ?.order_withdrawals,
            ) || 0;
        }
      }
      localStorage.setItem(
        "broker_count",
        JSON.stringify({
          total_deposits_thb,
          total_withdrawals_thb,
          total_balance_thb,
          order_deposits_thb,
          order_withdrawals_thb,
          total_deposits_lak,
          total_withdrawals_lak,
          total_balance_lak,
          order_deposits_lak,
          order_withdrawals_lak,
        }),
      );
    }
  };
  GetBadgeCount = async () => {
    // Count pending across every currency (THB, LAK, ...), not just THB.
    const currencies = (global.currency || []).map((c) => c.currency_code);
    const currency_list = currencies.length ? currencies : ["THB"];

    // Sum result.count (total, not page-capped) over all currencies.
    const sumCount = async (path, extra) => {
      const results = await Promise.all(
        currency_list.map((cur) =>
          GET(path, { page_size: 100, page: 1, ...extra, currency: cur }),
        ),
      );
      return results.reduce(
        (n, r) => n + (r?.count || r?.data?.length || 0),
        0,
      );
    };

    const [withdrawals_count, mismatch_count, settlements_hq_count] =
      await Promise.all([
        sumCount(`transactions/withdrawals/list`, {
          filter_status: "pending",
          is_hq: false,
        }),
        Promise.all(
          currency_list.map((cur) =>
            GET(`profits/list-mismatch`, {
              page_size: 100,
              page: 1,
              filter_status: "mismatch",
              currency: cur,
            }),
          ),
        ).then((results) =>
          results.reduce(
            (n, r) =>
              n +
              (r?.data?.filter?.((e) => e.status === "mismatch")?.length || 0),
            0,
          ),
        ),
        sumCount(`transactions/withdrawals/list`, {
          filter_status: "pending",
          process_type: "withdrawals",
          is_hq: true,
        }),
      ]);

    const label99 = (c) => (c >= 100 ? "99+" : String(c));

      // Build the badge with textContent so a count value can never be parsed
      // as HTML.
      const renderBadge = (el, count, label) => {
        el.replaceChildren();
        if (count > 0) {
          const span = document.createElement("span");
          span.className = "bg-danger rounded-4 px-1 text-12 text-white";
          span.textContent = label;
          el.appendChild(span);
        }
      };

      document.querySelectorAll("#badge-withdrawals").forEach(el => {
        renderBadge(el, withdrawals_count, label99(withdrawals_count));
      });

      document.querySelectorAll("#badge-mismatchs").forEach(el => {
        renderBadge(el, mismatch_count, label99(mismatch_count));
      });

      document.querySelectorAll("#badge-settlements-hq").forEach(el => {
        renderBadge(el, settlements_hq_count, label99(settlements_hq_count));
      });
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
    this.scrollActiveMenuIntoView();

    this.permissionSetting();
  }
  // เมนูเป็น <a href> โหลดหน้าใหม่ทุกครั้ง sidebar เลยกลับไปบนสุด ต้องเลื่อนให้เห็นเมนูที่เลือกอยู่
  scrollActiveMenuIntoView = () => {
    if (this.menuScrolled) return;
    // desktop กับ mobile render เมนูคนละชุด ต้องเลือกชุดที่มองเห็นอยู่ ไม่งั้น scroll ไม่ทำงาน
    const active = [...document.querySelectorAll("a.active")].find(
      (el) => el.offsetParent !== null,
    );
    const container = active?.closest(".overflow-scroll");
    if (!active || !container) return;
    this.menuScrolled = true;

    // เลื่อนเฉพาะ container ของ sidebar ไม่แตะ scroll ของหน้าหลัก
    const offset =
      active.getBoundingClientRect().top - container.getBoundingClientRect().top;
    container.scrollTop += offset - container.clientHeight / 2 + active.offsetHeight / 2;
  };
  componentWillUnmount() {
    if (this.switchSearchTimeout) {
      clearTimeout(this.switchSearchTimeout);
    }
    if (this.badgeInterval) {
      clearInterval(this.badgeInterval);
    }
  }
  filterMenu = (profile) => {
    let perms = profile?.role?.permission || [];
    perms.push("dashboard.read");
    if (profile?.user_type === "super_user") {
      perms.push("developer-mode.read");
      perms.push("products.read"); // super_user เห็นเสมอ role อื่นใช้สิทธิ์ products.read จาก role
    } else if (profile?.user_type === "admin") {
    } else if (profile?.user_type === "broker") {
    } else if (profile?.user_type === "admin_broker") {
      // perms.push("webhooks.read");
      perms = perms.filter((e) => e !== "brokers.read");
    } else if (profile?.user_type === "accounting") {
      perms = perms.filter((e) => e !== "agents.read");
      perms = perms.filter((e) => e !== "brokers.read");
      perms = perms.filter((e) => e !== "customers.read");
    } else if (profile?.user_type === "agent") {
      perms = perms.filter((e) => e !== "deposits.read");
      perms = perms.filter((e) => e !== "withdrawals.read");
      perms = perms.filter((e) => e !== "customers.read");
      perms = perms.filter((e) => e !== "brokers.read");
    }
    const menu = global.menu?.filter(
      (item) => !item.link || perms.includes(item.permission),
    );
    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };
  permissionSetting = () => {
    const role = new Set(this.state.user_profile?.role?.permission || []);
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
  };
  componentMenu = () => {
    const classNameBTN =
      "btn btn-outline-dark border-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-1 rounded-3";
    const classNameICON = "icon wpx-20 ms-1";
    const currentPath = `/${window.location.href.split("/").pop()}`;
    // key จำเป็นเมื่อถูกเรียกใน array_link.map (href ไม่ซ้ำกันในเมนู)
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        key={href}
        href={href}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
        style={{ borderRadius: 12 }}
      >
        <span className={classNameICON} style={{ borderRadius: 10 }}>
          {icon}
        </span>
        <div className="mx-2">{label}</div>
        {extra}
      </a>
    );

    const { array_link } = this.state;

    return (
      <div>
        {array_link.map((item, i) => {
          if (item.title)
            return (
              <div className="my-2 text-12" key={`title-${i}`}>
                <b>{item.title}</b>
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${
            item.type || item.country ? "?" + params : ""
          }`;
          const isActive = href === currentPath;
          return linkItem(
            `/${linkRole(profile?.user_type)}${href}`,
            item.icon,
            item.name,
            isActive,
            item.component,
          );
        })}

        <hr />

        {profile?.user_type === "broker" &&
          linkItem(
            `/${linkRole(profile?.user_type)}/connect-apis`,
            "\uf0c1",
            "Connect API",
            window.location.pathname === "/connect-apis",
          )}

        {linkItem(
          `/${linkRole(profile?.user_type)}/settings`,
          "\uf013",
          "Settings",
          window.location.pathname === "/settings",
        )}
        <div className="d-block d-xl-none">
          <button
            className={`${classNameBTN} text-danger`}
            style={{ borderRadius: 16 }}
            data-testid="btn-logout-mobile"
            onClick={async () => {
              this.Logout();
            }}
          >
            <span className={classNameICON} style={{ borderRadius: 12 }}>
              {"\uf2f5"}
            </span>
            <div className="mx-2">Logout</div>
          </button>
        </div>
        <div className="d-none d-xl-block hpx-100"></div>
      </div>
    );
  };
  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        "Confirm",
        "Press 'Logout' to confirm leaving this app?",
        "Logout",
        "cancel",
      )
    ) {
      loading(true);
      // การ์ด #31: ต้องยิงไป backend จริงเพื่อให้ httpOnly cookie ถูกเคลียร์ (Set-Cookie) ตอน logout
      // เดิม path "logout" ไม่ตรงกับ route ที่ mount จริงที่ "v1/public/logout" ทำให้ endpoint นี้ไม่เคยถูกเรียกจริง
      let result = await GET("v1/public/logout", null);
      if (result?.status) {
        const mode = localStorage.getItem("mode") || "light";
        localStorage.clear();
        localStorage.setItem("mode", mode);
        window.location.href = "/";
      }
      loading(false);
    }
  };
  OpenSwitchUserModal = async () => {
    this.setState(
      {
        modal_switch_user: true,
        switch_search: "",
        switch_user_type: "",
        switch_user_counts: {
          all: 0,
          admin: 0,
          accounting: 0,
          broker: 0,
          sub_broker: 0,
          agent: 0,
        },
        switch_selected_user: null,
      },
      async () => {
        await this.GetSwitchUsers();
        await this.GetSwitchUserCounts();
      },
    );
  };
  CloseSwitchUserModal = () => {
    this.setState({
      modal_switch_user: false,
      switch_search: "",
      switch_user_type: "",
      switch_user_counts: {
        all: 0,
        admin: 0,
        accounting: 0,
        broker: 0,
        sub_broker: 0,
        agent: 0,
      },
      switch_selected_user: null,
      switch_loading: false,
      switch_submitting: false,
    });
  };
  GetSwitchUsers = async (
    search = "",
    userType = this.state.switch_user_type,
  ) => {
    this.setState({ switch_loading: true });
    const result = await GET("v1/admin/users", {
      page_size: 20,
      page: 1,
      data_search: search,
      user_type: userType || "",
    });
    this.setState({
      switch_users: result?.status
        ? (result.data || []).filter(
            (u) => u.uid !== this.state.user_profile?.uid,
          )
        : [],
      switch_loading: false,
    });
  };
  GetSwitchUserCounts = async (search = "") => {
    const result = await GET("v1/admin/users", {
      page: 0,
      page_size: 100000,
      data_search: search,
    });
    const counts = {
      all: 0,
      admin: 0,
      accounting: 0,
      broker: 0,
      sub_broker: 0,
      agent: 0,
    };
    const rows = result?.status
      ? (result.data || []).filter(
          (u) => u.uid !== this.state.user_profile?.uid,
        )
      : [];
    rows.forEach((u) => {
      if (Object.prototype.hasOwnProperty.call(counts, u.user_type)) {
        counts[u.user_type] += 1;
      }
      counts.all += 1;
    });
    this.setState({ switch_user_counts: counts });
  };
  SwitchProfile = async () => {
    const { switch_selected_user } = this.state;
    if (!switch_selected_user?.uid) {
      alert("", "warning", "Warning", "Please select user");
      return;
    }
    const isConfirm = await alert(
      "",
      "warning",
      "Confirm",
      `Switch to "${switch_selected_user.full_name || switch_selected_user.email}" ?`,
      "Switch",
      "Cancel",
    );
    if (!isConfirm) return;

    this.setState({ switch_submitting: true });
    loading(true);
    const result = await POST("v1/admin/users/switch-profile", {
      user_id: switch_selected_user.uid,
      key: process.env.REACT_APP_CODE_HEX || "",
    });
    if (result?.status && result?.data?.token) {
      // การ์ด #31: token คือ httpOnly cookie ที่ backend ตั้งมาพร้อม response นี้แล้ว ไม่ต้องเก็บเอง
      // ส่วน csrf token หมุนใหม่ตามคุกกี้ชุดใหม่ ต้องเก็บทับค่าเดิม ไม่งั้น POST ถัดไปจะไม่ผ่านด่าน CSRF
      setCsrfToken(result.data.csrf_token);
      localStorage.setItem(
        "scp-profile",
        JSON.stringify({
          uid: switch_selected_user.uid,
          user_type: result.data.user_type || switch_selected_user.user_type,
          full_name:
            switch_selected_user.full_name ||
            switch_selected_user.email ||
            "User",
          email: switch_selected_user.email || "",
          secret: result.data.secret || "",
          is_2fa: result.data.is_2fa,
          verify_time: new Date(
            new Date().setMinutes(new Date().getMinutes() + 10),
          ).getTime(),
        }),
      );
      localStorage.removeItem("scp-2fa");
      if (result.data.is_2fa) {
        window.location.href = "/verify-2fa";
      } else {
        localStorage.setItem(
          "scp-2fa",
          btoa(
            switch_selected_user.uid +
              ":" +
              new Date(new Date().setDate(new Date().getDate() + 7)).getTime(),
          ),
        );
        window.location.href = `/${linkRole(
          result.data.user_type || switch_selected_user.user_type,
        )}/dashboard`;
      }
      return;
    }
    this.setState({ switch_submitting: false });
    loading(false);
  };
  SwitchUserComponent = () => {
    const {
      modal_switch_user,
      switch_users,
      switch_search,
      switch_user_type,
      switch_user_counts,
      switch_selected_user,
      switch_loading,
      switch_submitting,
    } = this.state;
    const userTypeTabs = [
      { label: "All", value: "" },
      { label: "Admin", value: "admin" },
      { label: "Accounting", value: "accounting" },
      { label: "Broker", value: "broker" },
      { label: "Sub Broker", value: "sub_broker" },
      { label: "Agent", value: "agent" },
    ];
    const typeTheme = {
      admin: { bg: "#d1e7dd", text: "#0f5132", border: "#badbcc" },
      agent: { bg: "#cff4fc", text: "#055160", border: "#b6effb" },
      broker: { bg: "#f2e3ff", text: "#5a2d82", border: "#e3c9ff" },
      sub_broker: { bg: "#cfe2ff", text: "#084298", border: "#b6d4fe" },
      accounting: { bg: "#fff3cd", text: "#664d03", border: "#ffecb5" },
      default: { bg: "#f8d7da", text: "#842029", border: "#f5c2c7" },
    };
    const activeTabStyle = {
      border: "none",
      color: "#1f1f1f",
      background:
        "linear-gradient(135deg, #f3dc8a 0%, #dabb55 55%, #b9922e 100%)",
      boxShadow: "0 2px 8px rgba(185, 146, 46, 0.28)",
    };
    const inactiveTabStyle = {
      border: "1px solid #eadfc0",
      color: "#7b6b3d",
      background: "#fffaf0",
    };
    return (
      <Modal
        show={modal_switch_user}
        onHide={this.CloseSwitchUserModal}
        centered
        size="md"
        style={{ "--bs-modal-width": "660px" }}
      >
        <Modal.Header
          closeButton
          style={{
            borderBottom: "1px solid #f0e6c8",
            background:
              "linear-gradient(180deg, rgba(243,220,138,0.28) 0%, rgba(255,255,255,1) 100%)",
          }}
        >
          <Modal.Title className="d-flex align-items-center">
            <span className="icon me-3">{"\uf362"}</span>
            Switch User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ minHeight: 460 }}>
          <div className="d-flex flex-wrap gap-2 mb-3">
            {userTypeTabs.map((tab) => (
              <button
                key={tab.value || "all"}
                className="btn btn-sm rounded-4"
                style={(() => {
                  if (switch_user_type !== tab.value) return inactiveTabStyle;
                  if (!tab.value) return activeTabStyle;
                  const theme = typeTheme[tab.value] || typeTheme.default;
                  return {
                    border: `1px solid ${theme.border}`,
                    color: theme.text,
                    background: theme.bg,
                  };
                })()}
                onClick={() => {
                  this.setState(
                    {
                      switch_user_type: tab.value,
                      switch_selected_user: null,
                    },
                    () => {
                      this.GetSwitchUsers(switch_search, tab.value);
                    },
                  );
                }}
              >
                {tab.label} ({switch_user_counts[tab.value || "all"] || 0})
              </button>
            ))}
          </div>
          <div className="mb-3">
            <label className="text-12 text-secondary mb-1">Search user</label>
            <input
              className="form-control"
              placeholder="Search by name, email, phone or user code"
              style={{
                borderColor: "#eadfc0",
                background: "#fffcf3",
              }}
              value={switch_search}
              onChange={(e) => {
                const value = e.target.value;
                this.setState({ switch_search: value });
                if (this.switchSearchTimeout) {
                  clearTimeout(this.switchSearchTimeout);
                }
                this.switchSearchTimeout = setTimeout(() => {
                  this.GetSwitchUsers(value, this.state.switch_user_type);
                  this.GetSwitchUserCounts(value);
                }, 250);
              }}
            />
          </div>
          <div className="row">
            <div className="col-12">
              <div
                className="border rounded-3 overflow-auto"
                style={{
                  maxHeight: 320,
                  borderColor: "#efe5c8",
                  background: "#fffdfa",
                }}
              >
                {switch_loading ? (
                  <div className="p-3 text-center text-secondary">
                    Loading...
                  </div>
                ) : switch_users.length ? (
                  switch_users.map((item) => (
                    <button
                      key={item.uid}
                      className={`btn w-100 text-start border-0 border-bottom rounded-0 px-3 py-2 pe-4 transition position-relative ${
                        switch_selected_user?.uid === item.uid ? "" : ""
                      }`}
                      style={{
                        borderBottomColor: "#f2ead0",
                        background:
                          switch_selected_user?.uid === item.uid
                            ? "linear-gradient(135deg,rgb(203, 157, 65) 0%,rgb(242, 217, 156) 45%,rgb(246, 240, 221) 100%)"
                            : "transparent",
                      }}
                      onClick={() => {
                        this.setState({ switch_selected_user: item });
                      }}
                    >
                      <div className="d-flex align-items-center w-100">
                        <div
                          className="fw-bold text-14 pe-2"
                          style={{ paddingRight: 140 }}
                        >
                          {item.full_name || "-"}
                        </div>
                      </div>
                      <div className="text-secondary text-12">
                        {item.email || "-"}
                      </div>
                      <span
                        className="text-11 text-uppercase px-3 py-1 rounded-3 d-inline-flex align-items-center justify-content-center text-center"
                        style={{
                          background: (
                            typeTheme[item.user_type] || typeTheme.default
                          ).bg,
                          color: (
                            typeTheme[item.user_type] || typeTheme.default
                          ).text,
                          minWidth: 110,
                          position: "absolute",
                          right: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        {item.user_type?.replaceAll("_", " ") || "-"}
                      </span>
                    </button>
                  ))
                ) : (
                  <div className="p-3 text-center text-secondary">
                    No users found
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-light"
            style={{ borderColor: "#eadfc0", background: "#fffaf0" }}
            onClick={this.CloseSwitchUserModal}
            disabled={switch_submitting}
          >
            Cancel
          </button>
          <button
            className="btn"
            style={{
              border: "none",
              color: "#fff",
              background:
                "linear-gradient(135deg, #8f6a1f 0%, #c89f35 45%, #e5c86e 100%)",
              boxShadow: "0 2px 8px rgba(185, 146, 46, 0.28)",
            }}
            onClick={this.SwitchProfile}
            disabled={!switch_selected_user || switch_submitting}
          >
            {switch_submitting ? "Switching..." : "Switch User"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };
  WalletComponent = () => {
    const {
      total_balance_available_thb,
      total_balance_available_lak,
      total_balance_thb,
      total_balance_lak,
    } = this.state;

    // ฟังก์ชันช่วยดึงข้อมูลยอดเงินตามสกุลเงิน เพื่อลดการเขียน Ternary operator ซ้ำๆ
    const getBalances = (currencyCode) => {
      const isTHB = currencyCode === "THB";
      return {
        available: isTHB
          ? total_balance_available_thb
          : total_balance_available_lak,
        total: isTHB ? total_balance_thb : total_balance_lak,
      };
    };

    // ฟังก์ชันช่วยหา Tier ที่ Active อยู่
    const getActiveTier = (item) => {
      return item.tiers?.find(
        (e) => e.is_active && e.currency === item.currency,
      );
    };

    // ฟังก์ชันช่วยดึงรูป Rank
    const getRankImage = (sequence) => {
      const ranks = [RANK1, RANK1, RANK2, RANK3, RANK4, RANK5, RANK6];
      return sequence !== undefined ? ranks[sequence] || RANK1 : RANK1;
    };

    return (
      <Dropdown>
        <Dropdown.Toggle
          bsPrefix="no-caret"
          className="d-flex align-items-center p-0"
          variant="gray"
          id="dropdown-wallet"
          size="sm"
        >
          <div className="nav-wallet-pill d-flex align-items-center text-end">
            {global.currency.map((item) => {
              const { available } = getBalances(item.currency_code);

              return (
                <div
                  className="nav-wallet-pill-item d-flex align-items-center"
                  key={`toggle-${item.currency_code}`}
                >
                  {item.image}
                  <div className="ms-2">
                    <div className="nav-wallet-pill-amount text-nowrap">
                      {toFixed(available)}
                    </div>
                    <div className="nav-wallet-pill-label">Balance</div>
                  </div>
                </div>
              );
            })}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="nav-wallet-menu">
          <div className="nav-wallet-menu-head">
            <div className="nav-wallet-eyebrow">Wallet</div>
            <div className="nav-wallet-title">Your balances</div>
          </div>
          {global.currency.map((item) => {
            const { available, total } = getBalances(item.currency_code);
            const activeTier = getActiveTier(item);
            const tierName = activeTier?.tier_name || "";
            const rankImgSrc = getRankImage(activeTier?.sequence);

            return (
              <div className="nav-wallet-card" key={`menu-${item.currency_code}`}>
                {/* ไอคอนและระดับ Rank */}
                <div className="nav-wallet-flag">
                  {item.image_big}
                  <img
                    className="nav-wallet-rank"
                    alt={tierName}
                    src={rankImgSrc}
                    width={16}
                    title={tierName}
                  />
                </div>

                {/* รายละเอียดจำนวนเงิน */}
                <div className="flex-grow-1 min-w-0">
                  <div className="nav-wallet-label">Balance</div>
                  <div className="nav-wallet-amount">
                    {toFixed(available)} <span>{item.currency_code}</span>
                  </div>
                  <div className="nav-wallet-sub">
                    <span className="nav-wallet-label mb-0">
                      Available (T+1){" "}
                      <span
                        className="icon pointer"
                        title="Available Balance (T+1) refers to the amount of money awaiting transaction clearance and will be available for use or withdrawal on the next business day. The system will update the Available Balance at 00:00."
                      >
                        {"\uf05a"}
                      </span>
                    </span>
                    <span className="nav-wallet-sub-amount">
                      {toFixed(total)} {item.currency_code}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  render() {
    const {
      user_profile,
      modal_news,
      announce_datetime,
      announce_duration,
      announce_detail,
      share_image,
    } = this.state;

    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-light position-fixed w-100 border-secondary-light"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid" }}
          expand="xl"
        >
          <Navbar.Brand
            href={`/${linkRole(profile?.user_type)}/dashboard`}
            className="fw-bold text-dark d-flex"
          >
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={35}
                style={{ objectFit: "contain" }}
                className="pointer d-none d-md-block"
                onClick={() => {
                  window.location.href = `/${linkRole(profile?.user_type)}/dashboard`;
                }}
              />
              <img
                alt="logo"
                src={LOGO512}
                height={30}
                style={{ objectFit: "contain" }}
                className="pointer d-none d-sm-block d-md-none"
                onClick={() => {
                  window.location.href = `/${linkRole(profile?.user_type)}/dashboard`;
                }}
              />
              <span
                className="position-absolute d-none d-md-block"
                style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}
              >
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            {localStorage.getItem("scp-original-profile") && (
              <button
                type="button"
                className="btn btn-danger btn-sm me-2 fw-bold text-nowrap"
                data-testid="btn-exit-impersonation"
                onClick={this.ExitImpersonation}
                title="Exit impersonation"
              >
                <span className="icon me-1">{""}</span>Exit
              </button>
            )}
            {user_profile?.user_type !== "agent" && (
              <div className="d-flex d-xl-none align-items-center">
                {this.WalletComponent()}
              </div>
            )}
            <Navbar.Toggle
              className="border-0"
              aria-controls="basic-navbar-nav"
            />
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                {user_profile?.user_type !== "agent" && this.WalletComponent()}
                <span
                  className={`icon p-2 pointer`}
                  onClick={() => {
                    localStorage.setItem(
                      "mode",
                      mode === "light" ? "dark" : "light",
                    );
                    window.location.reload();
                  }}
                >
                  {mode === "dark" ? "\uf186" : "\uf185"}
                </span>
                <div
                  className="hpx-40 mx-2 bg-secondary-light"
                  style={{ width: 1 }}
                />
                <div className="d-none d-xl-flex align-items-center text-start">
                  <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center">
                    {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="px-2">
                    <div className="text-14">
                      {user_profile?.full_name || "Username"}
                    </div>
                    <div
                      className="text-12 text-secondary"
                      style={{ marginTop: -2 }}
                    >
                      {user_profile?.user_type?.replaceAll("_", " ")}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-block d-xl-none mb-5 pt-4 overflow-scroll"
                style={{ height: "80vh" }}
              >
                {this.componentMenu()}
                {user_profile?.user_type === "broker" && (
                  <>
                    <hr />
                    {user_profile?.broker?.wallets
                      ?.filter((e) => e.currency !== "USD")
                      .map((item) => {
                        // 1. สร้าง Map สำหรับรูปภาพ (เอาไว้ระดับบนสุดของไฟล์หรือใน Component ก็ได้)
                        const rankImages = {
                          1: RANK1,
                          2: RANK2,
                          3: RANK3,
                          4: RANK4,
                          5: RANK5,
                          6: RANK6,
                        };
                        // 2. ดึงค่าจาก .find() ออกมาเก็บเป็นตัวแปร เพื่อไม่ต้องค้นหาซ้ำๆ
                        const activeBrokerTier =
                          user_profile?.broker?.tiers?.find(
                            (e) => e.is_active && e.currency === item.currency,
                          );
                        const activeItemTier = item.tiers?.find(
                          (e) => e.is_active && e.currency === item.currency,
                        );
                        return (
                          <div
                            className="d-flex justify-content-between fw-bold mb-2"
                            key={`wallet-${item.currency}`}
                          >
                            <div>
                              <img
                                className="me-2"
                                style={{ opacity: activeBrokerTier ? 1 : 0.1 }}
                                alt={activeItemTier?.tier_name || ""}
                                title={activeItemTier?.tier_name || ""}
                                src={
                                  rankImages[activeItemTier?.sequence] || RANK1
                                }
                                width={20}
                              />
                              {
                                global.currency?.find(
                                  (e) => e.currency_code === item.currency,
                                )?.image
                              }
                              {item.currency}
                            </div>
                            <div>{toFixed(item.balance)}</div>
                          </div>
                        );
                      })}
                  </>
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 bg-light overflow-scroll d-none d-xl-block border-secondary-light"
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
            borderRight: "1px solid",
          }}
        >
          <div
            className="d-flex position-fixed bg-light px-3 wpx-260 border-secondary-light"
            style={{
              border: "0",
              // borderBottom: "1px solid",
              // borderRight: "1px solid",
              paddingTop: 12,
              paddingBottom: 12,
            }}
          >
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={35}
                style={{ objectFit: "contain" }}
                className="pointer"
                onClick={() => {
                  window.location.href = `/${linkRole(profile?.user_type)}/dashboard`;
                }}
              />
              <span
                className="position-absolute"
                style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}
              >
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </div>
          <div className="px-3 mb-5" style={{ marginTop: 70 }}>
            {this.componentMenu()}
          </div>
          <div
            className="d-flex pt-2 position-fixed bg-light pb-3 px-3 wpx-260 border-secondary-light"
            style={{
              bottom: 0,
              border: "0",
              borderRight: "1px solid",
              borderTop: "1px solid",
            }}
          >
            <div className="d-flex align-items-center text-start w-100">
              <span className="bg-warning text-dark me-1 wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="px-2 w-100" style={{ minWidth: 0 }}>
                <div
                  className="text-14 text-truncate"
                  title={user_profile?.full_name || "Username"}
                >
                  {user_profile?.full_name || "Username"}
                </div>
                <div
                  className="text-12 text-secondary text-truncate"
                  style={{ marginTop: -2 }}
                  title={user_profile?.email}
                >
                  {user_profile?.email}
                </div>
              </div>
              <span
                className="icon p-2 pointer flex-shrink-0"
                data-testid="btn-logout-desktop"
                onClick={() => {
                  this.Logout();
                }}
              >
                {"\uf08b"}
              </span>
            </div>
          </div>
        </div>
        {modal_news && (
          <div
            className="w-100 min-vh-100 position-fixed d-flex align-items-center justify-content-center"
            style={{ zIndex: 20000, backgroundColor: "#222222cc" }}
            onClick={() => {
              this.setState({ modal_news: false });
            }}
          >
            <img
              className="d-none d-md-block"
              alt="share"
              src={share_image}
              style={{ maxWidth: "70%", maxHeight: "80vh" }}
              onError={(e) => {
                // ป้องกันการเกิด loop หากรูป NOTIFICATION ก็พังเช่นกัน
                if (e.target.src !== NOTIFICATION) {
                  e.target.src = NOTIFICATION;
                }
              }}
            />
            <img
              className="d-block d-md-none"
              alt="share"
              src={share_image}
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
              onError={(e) => {
                // ป้องกันการเกิด loop หากรูป NOTIFICATION ก็พังเช่นกัน
                if (e.target.src !== NOTIFICATION) {
                  e.target.src = NOTIFICATION;
                }
              }}
            />
          </div>
        )}
        {/* ปิดการใช้งานชั่วคราว — เมนู Switch User ยังไม่ได้เปิดใช้จริง
            (OpenSwitchUserModal ไม่ถูกเรียกจากที่ไหนอยู่แล้ว จึงเปิดโมดัลไม่ได้)
            ฝั่ง backend เปลี่ยนด่านของ /admin/users/switch-profile จาก CODE_HEX
            มาเป็นสิทธิ์ super_user จาก token แล้ว ถ้าจะเปิดเมนูนี้กลับมาใช้
            ให้เอา comment ออกแล้วต่อปุ่มเข้ากับ this.OpenSwitchUserModal
            หน้า Developer Mode (/su/developer-mode) ยังใช้ switch-profile ได้ตามปกติ */}
        {/* {this.SwitchUserComponent()} */}
        {/* SHARE */}
        <div
          className="body"
          style={{ opacity: 0, position: "absolute", left: -9999 }}
        >
          <div
            className="position-relative"
            id="share"
            style={{ background: "transparent", width: 720 }}
            ref={(el) => (this.share = el)}
          >
            <img
              src={NOTIFICATION}
              alt="Logo"
              className="img-fluid rounded-3"
              crossOrigin="anonymous"
            />
            <div
              className="text-center position-absolute w-100"
              style={{ top: "34%", color: "#ffffff" }}
            >
              <div className="fw-bold noti-text-date" style={{ fontSize: 40 }}>
                {format_date(announce_datetime, " dd mmmm yyyy", "en")}
              </div>
              <div
                className="fw-bold noti-text-time"
                style={{ marginTop: -12, fontSize: 40 }}
              >
                {format_date(announce_datetime, "hh:mm")} -{" "}
                {format_date(
                  new Date(
                    new Date(announce_datetime).setMinutes(
                      new Date(announce_datetime).getMinutes() +
                        Number(announce_duration || 0),
                    ),
                  ),
                  "hh:mm",
                  "en",
                )}
              </div>
            </div>
            <div
              className="text-center position-absolute w-100"
              style={{ top: "52%", color: "#ffffff", padding: "0% 15%" }}
            >
              <div
                className="mx-auto text-start noti-text-detail"
                style={{ fontSize: 20, whiteSpace: "pre-line" }}
              >
                {announce_detail ? (
                  <ul>
                    {announce_detail.split("\n").map((e, i) => (
                      <li key={i}>{e}</li>
                    ))}
                  </ul>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
